module.exports = __webpack_public_path__ + "img/swag.57a4ea5a.svg";